var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageUrl)?_c('img',{staticClass:"aurora-icon aurora-illustration",attrs:{"src":_vm.imageUrl,"data-icon":_vm.name,"data-illustration":_vm.name,"width":"24","height":"24","alt":"","aria-hidden":"true","draggable":false,"decoding":"async"}}):_c('AuroraIcon',{attrs:{"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }